import { ViewsManagementProvider } from '../../../js/providers/ViewsManagementProvider';
import { Fragment, useCallback, useState } from 'react';
import styled, { css } from 'styled-components';
import { Popover, PopoverBody, PopoverFooter, PopoverHeader } from 'foundations-components/transitional/components/Popover';
import { AddViewSearchInput } from './AddViewSearchInput';
import { ViewCategoryColumn } from './ViewCategoryColumn';
import { SupportedCategories } from '../ViewCategories';
import { trackOpenAddViewPopover } from '../../tracking/viewsManagementTracking';
import { PRODUCT_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import ProductsViewTourPopover from '../../tours/products/components/ProductsViewTourPopover';
import { Button } from 'foundations-components/transitional/components/Button';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FullHeightBody = styled.div.withConfig({
  displayName: "AddViewPopover__FullHeightBody",
  componentId: "sc-1j2jtpc-0"
})(["height:340px;"]);
const HeaderBackground = styled.div.withConfig({
  displayName: "AddViewPopover__HeaderBackground",
  componentId: "sc-1j2jtpc-1"
})(({
  theme: _theme
}) => {
  const theme = _theme;
  return css(["background-color:", ";border-bottom:1px solid ", ";width:100%;padding:", ";"], theme.color['fill-surface-raised'], theme.color['border-core-default'], theme.space['300']);
});
const AddViewPopoverListbox = styled.div.withConfig({
  displayName: "AddViewPopover__AddViewPopoverListbox",
  componentId: "sc-1j2jtpc-2"
})(["height:100%;width:100%;display:inline-grid;grid-auto-columns:minmax(70px,auto);grid-auto-flow:column;grid-template-rows:1fr;"]);
const AddViewPopoverCategory = styled.div.withConfig({
  displayName: "AddViewPopover__AddViewPopoverCategory",
  componentId: "sc-1j2jtpc-3"
})(({
  theme: _theme
}) => {
  const theme = _theme;
  return css(["height:100%;border-right:1px solid ", ";border-bottom:1px solid ", ";overflow:auto;&:last-child{border-right:none;}"], theme.color['border-core-default'], theme.color['border-core-default']);
});
export const AddViewPopoverPresentational = ({
  objectTypeId,
  namespace,
  footer,
  children,
  onChange,
  placement = 'bottom left'
}) => {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const [searchQueryString, setSearchQueryString] = useState('');
  const handleOnChange = useCallback(viewItem => {
    if (onChange) {
      setIsPopoverOpen(false);
      onChange(viewItem);
    }
  }, [onChange]);
  const handleOnOpenPopover = evt => {
    setSearchQueryString('');
    setIsPopoverOpen(evt.target.value);
  };
  const handleOnOpenButton = () => {
    if (!isPopoverOpen) {
      trackOpenAddViewPopover();
    }
    setSearchQueryString('');
    setIsPopoverOpen(currentOpenState => !currentOpenState);
  };
  return /*#__PURE__*/_jsx(Popover, {
    maxInlineSize: "60vw",
    content: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(PopoverHeader, {
        padding: "0",
        children: /*#__PURE__*/_jsx(HeaderBackground, {
          children: /*#__PURE__*/_jsx(AddViewSearchInput, {
            onChange: setSearchQueryString,
            value: searchQueryString,
            autoFocus: true
          })
        })
      }), /*#__PURE__*/_jsx(PopoverBody, {
        "data-test-id": "add-view-popover-body",
        padding: "0",
        children: /*#__PURE__*/_jsx(FullHeightBody, {
          children: /*#__PURE__*/_jsx(AddViewPopoverListbox, {
            children: SupportedCategories.map(category => {
              return /*#__PURE__*/_jsx(AddViewPopoverCategory, {
                "data-test-id": `add-view-popover-category-${category.toLowerCase()}`,
                children: /*#__PURE__*/_jsx(ViewCategoryColumn, {
                  namespace: namespace,
                  objectTypeId: objectTypeId,
                  query: searchQueryString,
                  category: category,
                  onChange: handleOnChange
                })
              }, category);
            })
          })
        })
      }), /*#__PURE__*/_jsx(PopoverFooter, {
        "data-test-id": "add-view-popover-footer",
        children: footer
      })]
    }),
    onOpenChange: handleOnOpenPopover,
    open: isPopoverOpen,
    placement: placement,
    inlineSize: "100%",
    arrowColor: "fill-surface-raised",
    "data-test-id": "add-view-popover",
    children: /*#__PURE__*/_jsx(Button, {
      use: "transparent",
      onClick: handleOnOpenButton,
      "data-test-id": "add-view-popover-button",
      paddingBlockEnd: "0",
      children: children
    })
  });
};
const AddViewPopover = ({
  objectTypeId,
  namespace,
  footer,
  children,
  onChange,
  placement
}) => {
  const shouldShowProductPopover = objectTypeId === PRODUCT_TYPE_ID;
  const ProductTourWrapper = shouldShowProductPopover ? ProductsViewTourPopover : Fragment;
  return /*#__PURE__*/_jsx(ViewsManagementProvider, {
    children: /*#__PURE__*/_jsx(ProductTourWrapper, {
      children: /*#__PURE__*/_jsx(AddViewPopoverPresentational, {
        objectTypeId: objectTypeId,
        namespace: namespace,
        footer: footer,
        onChange: onChange,
        placement: placement,
        children: children
      })
    })
  });
};
export default AddViewPopover;